import config from 'config'
import React, { Component } from "react"
import { withTranslation } from "react-i18next"
import { connect } from 'react-redux'
import { getNested } from 'srcReact/helpers/validator'

class ErrorPageUser extends Component {
    render() {
        const { t,current_organization } = this.props 
        const organizationName = getNested(current_organization, 'info', 'name')?current_organization.info.name:"";
        return (
            <div className="billing-error-page">
                <h2 className='billing-error-page__content-title'>{t('billing.errorPages.userPage.title',{organisation_name:organizationName})}</h2>
                <p className='billing-error-page__content-text'>{t('billing.errorPages.userPage.text')}</p>
                <div className="billing-error-page__content-image">
                    <img src={`${config.assetUrl}/images/void.svg`} alt='urban-design' />
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
  const {organization:{current_organization}} = state
  return { current_organization }
}

const ExtendedComponent = withTranslation('common')(ErrorPageUser);
const connectedErrorPageUser = connect(mapStateToProps)(ExtendedComponent)
export { connectedErrorPageUser as ErrorPageUser }
